export const map = (map) => {

  const locationItem = $('.js-location-item');

  const init = () => {

    var Styled = [
      {
        "elementType": "geometry",
        "stylers": [
          {
            "lightness": -5
          }
        ]
      },
      {
        "elementType": "labels",
        "stylers": [
          {
            "color": "#c0c0c0"
          }
        ]
      },
      {
        "elementType": "labels.text.stroke",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "lightness": -5
          },
          {
            "weight": 4
          }
        ]
      },
      {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#f8f8f8"
          }
        ]
      },
      {
        "featureType": "poi",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#eeeeee"
          },
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi",
        "elementType": "labels.text",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road",
        "stylers": [
          {
            "color": "#d6d6d6"
          },
          {
            "visibility": "simplified"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#ffffff"
          }
        ]
      },
      {
        "featureType": "road",
        "elementType": "labels",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#eaeaea"
          },
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#616161"
          }
        ]
      },
      {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      },
      {
        "featureType": "transit",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "transit.station",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "water",
        "stylers": [
          {
            "color": "#CCCCCC"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
          {
            "color": "#eaeaea"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text",
        "stylers": [
          {
            "visibility": "off"
          }
        ]
      },
      {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
          {
            "color": "#9e9e9e"
          }
        ]
      }
    ];

  	var myLatLng = {lat: 52.519325, lng: 13.392709};

  	var options = {
  		zoom: 5,
  		center: myLatLng,
  		disableDefaultUI: true,
  		scrollwheel: false,
  		navigationControl: false,
      zoomControl: true,
      zoomControlOptions: {
          style: google.maps.ZoomControlStyle.SMALL,
          position: google.maps.ControlPosition.RIGHT_TOP
      },
      scaleControl: true,
      scrollwheel: false,
      fontSize: "8px",
      label: {
        fontSize: "8px"
      },
  		mapTypeControlOptions: {
  			mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain',
  					'Styled']
  		},
  		mapTypeId: 'Styled'
    };

  	var map = new google.maps.Map(document.getElementById('map'), options);

  	var styledMapType = new google.maps.StyledMapType(Styled, { name: 'Styled' });
  	map.mapTypes.set('Styled', styledMapType);

    var iconBase = document.location.origin + '/assets/images/';
    var icons = {
      locationHover: {
        icon: iconBase + 'custom-pin.svg'
      },
      location: {
        icon: iconBase + 'custom-pin.svg'
      }
    };

    function addMarker(location) {

      var marker = new google.maps.Marker({
        position: location.position,
        icon: icons[location.type].icon,
        map: map
      });

      var infowindow = new google.maps.InfoWindow({
        content: '<p><b>'+location.title+'</b><br>'+location.address
      });

      google.maps.event.addListener(marker, 'mouseover', function() {
        marker.setIcon(icons['locationHover'].icon);
        infowindow.open(map, marker);
      });

      google.maps.event.addListener(marker, 'mouseout', function() {
        marker.setIcon(icons[location.type].icon);
        infowindow.close(map, marker);
      });

      // google.maps.event.addListener(marker, 'click', function() {
      //   infowindow.open(map, marker);
      // });

    }

    var locations = [];
    collectLocationData();

    function collectLocationData() {

      var locationHref = [];
      var locationSlug = [];
      var locationTitle = [];
      var locationAddress = [];
      var locationLatitude = [];
      var locationLongitude = [];

      locationItem.each(function(index) {

        var $href = $(this).attr('data-href');
        var $website = $(this).attr('data-website');
        var $title = $(this).attr('data-title');
        var $address = $(this).attr('data-location');
        var $latitude = $(this).attr('data-latitude');
        var $longitude = $(this).attr('data-longitude');

        locations.push({
          id: index,
          href: $href,
          website: $website,
          title: $title,
          address: $address,
          position: new google.maps.LatLng($latitude, $longitude),
          type: 'location'
        });

      });

    }

    for (var i = 0, location; location = locations[i]; i++) {
      addMarker(location);
    }

  };

  if ($(map).length > 0) {
    init();
  }

};
